// Lightweight speech helper shared by driver turn-by-turn and rider trip notifications.
let enabled = true;

export function setVoiceEnabled(v) {
  enabled = v;
  if (!v) cancelVoice();
}

export function cancelVoice() {
  try { window.speechSynthesis?.cancel(); } catch { /* noop */ }
}

export function speak(text, { force = false, interrupt = true } = {}) {
  if (!text) return;
  if (!enabled && !force) return;
  if (typeof window === "undefined" || !window.speechSynthesis) return;
  try {
    if (interrupt) window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.rate = 1; u.pitch = 1.02; u.lang = "en-US";
    window.speechSynthesis.speak(u);
  } catch { /* noop */ }
}
